/* eslint-disable @typescript-eslint/no-unused-expressions */
import { energyApi } from "utilities/Axios";

function subtractHours(date: any) {
  date.setHours(date.getHours() - 720);
  return date;
}

const dateNow = new Date();
const dateTime = subtractHours(dateNow);

export const getAllTags = () => {
  return energyApi.get("/TagMeta/GetAllTags");
};

export const getTagData = (
  ids: any,
  dateTime?: string,
) => {
  let url = "Dashboard/GetTagData";
  dateTime ? (url += `?dateTime=${dateTime}`) : null;
  return energyApi.post(url, ids);
};

export const mapEquipmentTag = (tags: any) => {
  return energyApi.post("/TagMeta/MapEquipmentTag", tags);
};

export const mapTrainTag = (tags: any) => {
  return energyApi.post("/TagMeta/MapTrainTag", tags);
};

export const mapUnitTag = (tags: any) => {
  return energyApi.post("/TagMeta/MapUnitTag", tags);
};

export const getAllTagsWithParents = () => {
  return energyApi.get("/TagMeta/GetAllTagsWithParent");
};

export const createTag = (tag: any) => {
  return energyApi.post("/TagMeta/CreateTag", tag);
};

export const updateTag = (tag: any) => {
  return energyApi.post("/TagMeta/UpdateTag", tag);
};

export const resetTag = (id: any) => {
  return energyApi.get(`/TagMeta/ResetTagRange?id=${id}`);
};

export const uploadTag = (data: any, signal: any) => {
  return energyApi.post("TagData/Upload", data);
};

export const deleteTag = (id: any) => {
  return energyApi.get(`/TagMeta/DeleteTag?id=${id}`);
};

export const deleteTags = (ids: any) => {
  return energyApi.post(`/TagMeta/DeleteTags`, ids);
};

export const getTrainsByPlantId = (id: any) => {
  return energyApi.get(`/TagMeta/GetTrainsByPlantId?id=${id}`);
};

export const disableTag = (tagId: number, status: any) => {
  return energyApi.post(
    `/TagMeta/SetTagDisabled?tagId=${tagId}&isDisabled=${status}`
  );
};

export const getTagsByEquipmentsId = (equipmentId: any) => {
  return energyApi.get(`/TagMeta/GetTagsByEquipmentsId?id=${equipmentId}`);
};

export const getTagsByUnitId = (unitId: any) => {
  return energyApi.get(`/TagMeta/GetTagsByUnitId?id=${unitId}`);
};

export const getTagsByTrainId = (unitId: any) => {
  return energyApi.get(`/TagMeta/GetTagsByTrainId?id=${unitId}`);
};

export const downloadTag = (id: any) => {
  return energyApi.get(`/TagData/DownloadTagData?id=${id}`);
};

export const clearTag = (id: any) => {
  return energyApi.get(`/TagData/ClearTagData?id=${id}`);
};

export const mapUnityEquipmentHash = (data: any) => {
  return energyApi.post(`/TagMeta/SetEquipmentUnityHash`, data);
};